import React from 'react';
import PropTypes from 'prop-types';
import { limitTo, rupiah, currencyFormatter } from 'utils/formatter';
import styles from 'components/receipt/commons/ListItemBox/ItemTable.css';

class ItemTable extends React.Component {
  render() {
    const { checkouts, checkoutPriceFormatter } = this.props;
    return (
      <table
        className={`table table-responsive no-border ${
          styles['checkout-table']
        }`}
      >
        <tbody>
          {checkouts.map(checkout => (
            <tr key={checkout.id}>
              <td className={styles['checkout-cell']}>
                <div className={styles['item-main']}>
                  <div className={styles['text-left']}>
                    {limitTo(checkout.item_name, 25)}{' '}
                    {checkout.item_name.length > 25 ? '...' : ''}
                  </div>
                  <div className={styles['text-center']}>
                    x{Math.abs(checkout.quantity)}
                  </div>

                  <div className={styles['text-right']}>
                    {checkoutPriceFormatter(checkout.price)}
                  </div>
                </div>

                {checkout.item_variant_name && (
                  <div className={styles['item-variant-box']}>
                    <div className={styles['text-left']}>
                      {limitTo(checkout.item_variant_name, 45)}{' '}
                      {checkout.item_variant_name.length > 45 ? '...' : ''}
                    </div>
                  </div>
                )}

                {checkout.modifiers.length > 0 && (
                  <div className={styles['item-modifier-box']}>
                    {checkout.modifiers.map((modifier, i) => (
                      <div className={styles['item-modifier']} key={i}>
                        <div className={styles['text-left']}>
                          {limitTo(modifier.modifier_name, 15)}{' '}
                          {modifier.modifier_name.length > 15 ? '...' : ''} -
                          &nbsp;
                          {limitTo(modifier.modifier_option_name, 15)}{' '}
                          {modifier.modifier_option_name.length > 15
                            ? '...'
                            : ''}{' '}
                          - &nbsp;
                          {rupiah(modifier.price)}
                        </div>
                        <div className={styles['text-right']} />
                      </div>
                    ))}
                  </div>
                )}

                {checkout.discounts.length > 0 && (
                  <div className={styles['discount-box']}>
                    {checkout.discounts.map(discount =>
                      discount.discount_hash.map(
                        (disc, i) =>
                          disc.discount_type.toLowerCase() === 'percentage' && (
                            <div className={styles.discount} key={i}>
                              <div className={styles['text-left']}>
                                {limitTo(disc.discount_name, 25)}{' '}
                                {disc.discount_name.length > 25 ? '...' : ''}(
                                {this._percentageDiscountFormatter(
                                  disc.discount_percentage
                                )}
                                %)
                              </div>
                              <div className={styles['text-right']}>
                                {Number.isFinite(-disc.discount_amount) &&
                                  currencyFormatter(-disc.discount_amount)}
                              </div>
                            </div>
                          )
                      )
                    )}
                  </div>
                )}

                {checkout.note && (
                  <div className={styles['item-note']}>
                    <div className={styles['text-left']}>
                      <span>
                        <div>{checkout.note}</div>
                      </span>
                    </div>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  _percentageDiscountFormatter = discount => {
    return parseFloat(discount);
  };
}

ItemTable.propTypes = {
  checkouts: PropTypes.array,
  checkoutPriceFormatter: PropTypes.func,
};

export default ItemTable;
